export default __webpack_public_path__ + "static/media/nayeems-zone.6ca17263.png";